import { useEffect, useState } from 'react';
import { buildQuerySummary } from '@coveo/headless';
import headlessEngine from 'lib/utils/coveo/headlessEngine';
import { isEditorActive, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';

const useQuerySummary = (): number => {
  const controller = buildQuerySummary(headlessEngine);
  const [state, setState] = useState(controller.state);
  const { sitecoreContext } = useSitecoreContext();

  useEffect(() => {
    if (isEditorActive() || sitecoreContext?.pageState === 'preview') {
      return;
    }
    controller.subscribe(() => setState(controller.state));
  }, []);

  return state.total;
};

export default useQuerySummary;
